import { render, staticRenderFns } from "./NavbarLeft.vue?vue&type=template&id=8bbfab00&scoped=true"
import script from "./NavbarLeft.vue?vue&type=script&lang=js"
export * from "./NavbarLeft.vue?vue&type=script&lang=js"
import style0 from "./NavbarLeft.vue?vue&type=style&index=0&id=8bbfab00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbfab00",
  null
  
)

export default component.exports